export default __webpack_public_path__ + "static/media/lightSensorActive.95f40d7b.svg";